import React, { useState } from 'react'
import SbEditable from "storyblok-react"
import Slider from "react-slick";
import resolveLink from 'src/utils/resolveLink'
import RichText from 'src/utils/RichText'
import Label from 'src/components/Label'
import Heading from 'src/components/Heading'
import { Link } from 'gatsby';

const Logo = (props) => {
    const classes = "col-span-1 flex justify-center items-center"
    // Doing this to avoid annoying console warning about alt tags
    // eslint-disable-next-line
    const img = <img src={props.image?.filename} alt={props.image?.alt}/>
    return props.target?.cached_url ? (
        props.target.linktype !== 'story' ?
        <a href={props.target?.cached_url} className={classes} target="_blank" rel="noreferrer">
            {img}
        </a>
        :
        <Link to={resolveLink(props.target?.cached_url)} className={classes}>
            {img}
        </Link>
    ) :
    (
        <div className={classes}>
            {img}
        </div>
    )
}

const LogoCloudsSlider = ({blok}) => {

    const [currentIndex, setCurrentIndex] = useState(0);

    const settings = {
        dots: true,
        infinite: blok.logos.length > 1,
        speed: 500,
        autoplay: blok.logos.length > 1,
        autoplaySpeed: 8000,
        slidesToShow: blok.logos.length > 4 ? 5 : blok.logos.length,
        slidesToScroll: 5,
        dotsClass: `slick-dots lg:!block !hidden !-bottom-8`,
        beforeChange: (current, next) => setCurrentIndex(next),
        appendDots: dots => (
            <div>
            <ul className="">
                {dots.map((item, index) => (
                    <li className="!m-[2px] !h-[6px] !w-[6px]" key={index}>
                    {item.props.children}
                    </li>
                ))}
            </ul>
        </div>
          ),
        customPaging: i => (
            <div
                className={`relative w-full h-full transition-colors rounded-full duration-300 ${
                i === currentIndex/5 ? "bg-blue" : "bg-darkblue-200"
                }`}
            ></div>
        ),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: blok.logos.length > 3 ? 3 : blok.logos.length,
                    slidesToScroll: blok.logos.length > 3 ? 3 : blok.logos.length,
                    infinite: blok.logos.length > 3,
                    autoplay: blok.logos.length > 3,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: blok.logos.length > 2 ? 2 : blok.logos.length,
                    slidesToScroll: blok.logos.length > 2 ? 2 : blok.logos.length,
                    infinite: blok.logos.length > 2,
                    autoplay: blok.logos.length > 2,
                }
            },
        ]
    };

    return (
        <SbEditable content={blok} key={blok._uid}>
            <div className="bg-white">
                <div className="max-w-7xl mx-auto px-6 py-24 lg:py-36">
                    <div className="flex flex-col justify-center items-center gap-2">
                        <Label className="text-teal">{blok.label}</Label>
                        <Heading size="h3" className="text-center max-w-[820px] mt-4">{blok.title}</Heading>
                        <div className="prose leading-[22px] text-center max-w-[820px] lg:text-base text-sm">
                            <RichText>{blok.description}</RichText>
                        </div>
                    </div>
                    {!blok.disable_slider ?
                        <Slider {...settings} className="mt-10 overflow-hidden">
                            {blok.logos?.map((logo) => (
                                <Logo {...logo}/>
                            ))}
                        </Slider>
                        :
                        <div className="grid grid-cols-2 gap-12 md:grid-cols-3 lg:grid-cols-5 mt-10">
                            {blok.logos?.map((logo) => (
                                <Logo {...logo}/>
                            ))}
                        </div>
                    }
                </div>
            </div>
      </SbEditable>
    )
  };

export default LogoCloudsSlider;
  